import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const fn = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Retour en haut"
          style={{
            position: 'fixed', bottom: 100, right: 28, zIndex: 80,
            width: 40, height: 40,
            display: 'grid', placeItems: 'center',
            border: '1px solid rgba(255,255,255,0.25)',
            background: 'rgba(4,4,10,0.7)',
            backdropFilter: 'blur(12px)',
            color: '#fff',
            fontFamily: 'var(--mono)',
            fontSize: 16,
          }}
        >
          ↑
        </motion.button>
      )}
    </AnimatePresence>
  );
}
